import dayjs from "dayjs";

const formatDate = (iso: string | undefined | null): string =>
	iso ? dayjs(iso).format("DD MMM YYYY") : "";

export const adaptQuickLink = (data: IQuickLink): QuickLink => {
	return {
		id: data.id,
		heading: data.heading,
		content: data.content,
		buttonLink: data.button_link,
		appLink: data.app_link,
		modalLink: data.modal_link,
		webview: data.webview,
		feedId: data.feed_id ?? null,
		feed: data.feed ? { uuid: data.feed.uuid, name: data.feed.name } : null,
		published: data.published,
		order: data.order,
		createdBy: data.created_by
			? {
					id: data.created_by.id,
					firstName: data.created_by.first_name,
					lastName: data.created_by.last_name
				}
			: undefined,
		createdAt: formatDate(data.created_at),
		updatedAt: formatDate(data.updated_at),
		audienceGroups: data.audience_groups ?? []
	};
};

export const adaptQuickLinks = (data: IQuickLink[]): QuickLink[] => {
	return data.map(adaptQuickLink);
};
